import classNames from 'classnames';
import { StatDisplay, StatDisplayProps } from 'app/agriculture/components/StatDisplay/StatDisplay';
import { BatteryIcon } from 'app/agriculture/icons/BatteryIcon';
import './BatteryStat.scss';
import { useSnapshot } from 'app/agriculture/queries/snapshots/useSnapshot';

interface BatteryStatProps extends StatDisplayProps {
    deviceId: string;
}

export function BatteryStat({
    deviceId,
    className,
    ...statDisplayProps
}: Exclude<BatteryStatProps, 'value'>) {
    const powerSnapshot = useSnapshot({
        parentId: deviceId,
        snapshotType: 'Power',
        shelfLife: { hours: 1 },
    });

    return (
        <StatDisplay
            {...statDisplayProps}
            className={classNames(className, 'BatteryStat')}
            Icon={({ className, ...props }) => (
                <BatteryIcon
                    {...props}
                    className={classNames(className, 'BatteryStat__icon')}
                    batteryLevel={powerSnapshot?.batteryLevel ?? 0}
                    size={32}
                />
            )}
            value={powerSnapshot?.batteryLevel ?? null}
            unit="%"
        />
    );
}
